import { render } from "./ProductDetailPimTab.vue?vue&type=template&id=219875f3&scoped=true&ts=true"
import script from "./ProductDetailPimTab.vue?vue&type=script&lang=ts"
export * from "./ProductDetailPimTab.vue?vue&type=script&lang=ts"

import "./ProductDetailPimTab.vue?vue&type=style&index=0&id=219875f3&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219875f3"]])

export default __exports__